export const cookiesNameStatic = {
  ACCESS_TOKEN: "TC_accessToken",
  IS_AUTHENTICATED: "TC_isAuthenticated",
  CHECK_3PARTY_AVAILAPILITY: "TC_C3PAC",
  USER_IDENTIFIER: "TC_U",
};
